import BackendModel from 'ln/model/BackendModel';
// import { mapper } from 'ln/model/Mapper';
import { backend } from '../../setup';

class UserModel extends BackendModel {

	constructor( json:Object ){
		super( json );	
	}

	get id():number {
		return this.get<number>( 'id' );
	}
	
	get username():string {
		return this.get<string>( 'username' );
	}

	set username( u:string ) {
		this.set( 'username', u );
	}

	get email():string {
		return this.get<string>( 'email' );
	}
}

export default UserModel;


backend.mapper.toModel.add( 'App\\User', function( json ){
	return new UserModel( json );
});

backend.mapper.toJson.add( 'App\\User', function( model:UserModel ) {
	return model.object();
});